/**
 * This file generates code that will be used in the final page
 * no imported code can be used in any component. everything must be here.
 */
import { reindent } from "./CodeGenerator";

function getNamespace(ref) {
  if (!ref.id) return;
  const path = [ref.id];
  let parentNode = ref.parentNode;
  while (parentNode.id !== "root") {
    if (parentNode.id) path.unshift(parentNode.id);
    parentNode = parentNode.parentNode;
  }
  return path.join(".");
}

function generateUID() {
  var firstPart = (Math.random() * 46656) | 0;
  var secondPart = (Math.random() * 46656) | 0;
  firstPart = ("000" + firstPart.toString(36)).slice(-3);
  secondPart = ("000" + secondPart.toString(36)).slice(-3);
  return firstPart + secondPart;
}

function topicMatches(match, path) {
  if (match === path) return true;
  const matchTokens = match.split(".");
  const pathTokens = path.split(".");
  let matchedTokens = [];
  let idx = 0;
  matchTokens.forEach((t, i) => {
    if (t === "#") {
      const cTokens = pathTokens.slice(idx);
      let matched;
      if (matchTokens[i + 1]) {
        const cIdx = cTokens.indexOf(matchTokens[i + 1]);
        matched = pathTokens.slice(idx, idx + cIdx);
        idx = idx + cIdx;
      } else {
        matched = pathTokens.slice(idx);
      }
      if (matched.length === 0) matched.push(false);
      matchedTokens = [...matchedTokens, ...matched];
    } else if (t === "+") {
      matchedTokens.push(pathTokens[idx]);
      idx++;
    } else {
      matchedTokens.push(t === pathTokens[idx] ? pathTokens[idx] : false);
      idx++;
    }
  });
  return matchedTokens.join(".") === pathTokens.join(".");
}

function topicMatcher(map, namespace) {
  if (namespace in map) return map[namespace];
  const topics = Object.keys(map).filter(
    (f) => f.includes("+") || f.includes("#")
  );
  if (topics.length) {
    for (let t of topics) {
      const matches = topicMatches(t, namespace);
      if (matches) {
        return map[t];
      }
    }
  }
}

function PubSub() {
  const subscribers = {};
  function publish(namespace, topic, data) {
    const topics = topicMatcher(subscribers, namespace);
    if (!topics) return;
    const listeners = topics[topic];
    if (listeners)
      Object.keys(listeners).forEach((key) => {
        listeners[key](data);
      });
  }
  function subscribe(namespace, topic, callback) {
    if (subscribers[namespace] === undefined) {
      subscribers[namespace] = {};
    }
    const listeners = subscribers[namespace];
    if (listeners[topic] === undefined) {
      listeners[topic] = {};
    }
    const id = generateUID();
    listeners[topic][id] = callback;
    return () => {
      delete listeners[topic][id];
      if (Object.entries(listeners[topic]).length === 0)
        delete listeners[topic];
      if (Object.entries(subscribers[namespace]).length === 0)
        delete subscribers[namespace];
    };
  }
  return {
    publish,
    subscribe,
    subscribers,
  };
}

function initComponent(ref, component) {
  if (component.style) {
    for (let i in component.style) {
      ref.style[i] = component.style[i];
    }
  }
  if (component.attribute) {
    if (component.attribute.id) {
      ref.setAttribute("id", component.attribute.id);
    }
    if (component.attribute.className) {
      ref.classList.add(component.attribute.className);
    }
  }
}

function List(parent, component) {
  const ref = document.createElement("div");
  initComponent(ref, component);
  ref.classList.add("ls");
  if (component.name === "Vertical List") ref.classList.add("v");
  component.children.forEach((c) => {
    new Schema(ref, c);
  });
  parent.appendChild(ref);
}

function Button(parent, component) {
  const ref = document.createElement("button");
  initComponent(ref, component);
  ref.innerText = component.value;
  ref.addEventListener("click", () => {
    window.pubSub.publish(getNamespace(ref), "onclick", {});
  });
  parent.appendChild(ref);
}

function Panel(parent, component) {
  const ref = document.createElement("div");
  initComponent(ref, component);
  ref.classList.add("pn");
  const head = document.createElement("div");
  head.classList.add("pn-h");
  head.innerText = component.value;
  ref.appendChild(head);
  const body = document.createElement("div");
  body.classList.add("pn-b", "c");
  ref.appendChild(body);
  if (component.children) new Schema(body, component.children);
  parent.appendChild(ref);
}

function Schema(parent, component) {
  if (component.type === "BUTTON") new Button(parent, component);
  if (component.type === "PANEL") new Panel(parent, component);
  if (component.type === "LIST") new List(parent, component);
}

export default function makeApp(tree) {
  const modules =
    [
      getNamespace,
      generateUID,
      topicMatches,
      topicMatcher,
      PubSub,
      initComponent,
      List,
      Button,
      Panel,
      Schema,
    ]
      .map((f) => f.toString())
      .join("\n\n") + "\n\n";
  const body = tree.body || {};
  function getComponents() {
    const components = Object.keys(body).map((i) => {
      let component = body[i];
      return reindent(
        `new Schema(ref, ${JSON.stringify(component, null, 2)})`,
        1
      );
    });
    if (components.length) {
      return "\n  " + components.join("\n");
    }
    return "";
  }
  const onLoad = tree.onLoad
    ? reindent(tree.onLoad, 1) + "\nonLoad(window.pubSub);\n"
    : "";
  return `${modules}function App() {
  window.pubSub = new PubSub()
  ${onLoad}const ref = document.createElement('div')${getComponents()}
  return {
    ref
  }
}`;
}
